import React from 'react';
import _ from 'lodash';

import {
  getSearches,
  fetchSearch,
  transformDisplaySalesOrder,
  DisplaySalesOrder,
} from 'services/salesOrders';
import { fetchRepresentatives } from 'services/representatives';
import { fetchCustomers } from 'services/customers';
import { fetchOrderPriorities } from 'services/settings/orderPriorities';
import { fetchUsers } from 'services/user';
import { fetchUsers as fetchUsersV2 } from 'services/userV2';
import { fetchLocations } from 'services/locations';
import { fetchCarriers } from 'services/carriers';
import { fetchPaymentTerms } from 'services/paymentTerms';
import { fetchSettingsShipping } from 'services/settings/shipping/redux';
import { fetchTaxRates } from 'services/taxRates';
import { fetchUoms } from 'services/uoms';
import { fetchSettingsSalesOrders } from 'services/settings/salesOrders';
import { withSearchResults } from 'ui/components/Page/WithSearchResults';
import { fetchSettingsCompanies } from 'services/settings/company/redux';
import { fetchVendors } from 'services/vendors';
import { fetchTags } from 'services/tags';
import { fetchClasses } from 'services/classes';
import { Routes } from '../../navigation';
import { Dates } from 'helpers';
import { SALES_ORDER_COLUMNS } from './components';
import { SalesOrderPageProps } from './types';
import { initialPagination } from './consts';
import SalesOrderPageContainer from './SalesOrderPage.container';

export const SalesOrderPage = (props: SalesOrderPageProps) => {
  return <SalesOrderPageContainer {...props} />;
};

SalesOrderPage.route = Routes.SalesOrderPage;

export default withSearchResults<DisplaySalesOrder>(SalesOrderPage, {
  url: '/sales-mgmt/v1/orders?showStockStatus=true',
  expand: '',
  dataAdapter: transformDisplaySalesOrder,
  columns: SALES_ORDER_COLUMNS(Dates.DateCreated),
  getSearches,
  fetchSearch,
  initialPagination,
  quickSearchColumns: [
    'number',
    'salesOrderStatus',
    'customer.name',
    'representative.firstName',
    'location.name',
    'salesOrderItems.name',
    'salesOrderItems.saleItem.name',
    'salesOrderItems.saleItem.sku',
    'salesOrderBundleItems.item.name',
  ],
  rehydrationThunks: [
    fetchCustomers,
    fetchUsers,
    fetchUsersV2,
    fetchLocations,
    fetchPaymentTerms,
    fetchCarriers,
    fetchOrderPriorities,
    fetchTaxRates,
    fetchTags,
    fetchUoms,
    fetchRepresentatives,
    fetchSettingsCompanies,
    fetchSettingsSalesOrders,
    fetchSettingsShipping,
    fetchVendors,
    fetchClasses,
  ],
});
